var exports = {
  "uW": "x8b4e8595--dd522d--section",
  "wx": "x8b4e8595--dd522d--header",
  "RY": "x8b4e8595--dd522d--carousel-wrapper",
  "Dk": "x8b4e8595--dd522d--carousel",
};

module.exports = exports;
